<template>
    <div>
        <div v-if="isSubtypesFetching" class="text-muted">
            Loading...
        </div>
        <div v-else-if="filtererSubtypes.length === 0" class="text-muted">
            No data
        </div>
        <template v-else>
            <div class="list-group">
                <div v-for="subtype in filtererSubtypes" :key="subtype.key"
                     @click="editSubtype(subtype)"
                     class="list-group-item p-0">
                    <DocSubtypeSettingsListItem
                        :subtype="subtype"
                        :subtypes="filtererSubtypes"
                        :isSelected="selectedSubtype ? selectedSubtype.key === subtype.key : false"
                        :isLoading="false"
                        :isSaving="false"
                        @edit="editSubtype(subtype)"
                        @refresh="onRefresh"
                        @deleted="deleteSubtype(subtype)"/>
                </div>
            </div>
            <div @click="onCopyToTeam" v-if="filtererSubtypes.length !== 0"
                 class="text-purple d-inline-block clickable font-12 mt-2">
                <span class="pr-2">
                    <i class="fal fa-file-import"></i>
                </span>
                <span class="pr-1">Copy to team</span>
            </div>
        </template>

        <DocSubtypeCreate
            name="add-document-subtype"
            :docTypeKey="docType.type"
            @refresh="fetchDocSubtypes"/>
        <DocSubtypeCopyToTeam name="copy-doc-subtypes-to-team"/>
        <DocSubtypeIconEditor name="edit-doc-subtype-icon"/>
    </div>
</template>

<script>
import DocSubtypeCreate from './DocSubtypeCreate'
import DocSubtypeSettingsListItem from './form/DocSubtypeSettingsListItem'
import {showErrorMessage} from '@/services/snackbar'
import {documentTypesApiService} from '@/api/document/types'
import DocSubtypeCopyToTeam from '@/views/documents/subtypes/DocSubtypeCopyToTeam'
import DocSubtypeIconEditor from '@/views/documents/subtypes/icon/DocSubtypeIconEditor'
import EventBus from '@/command/bus'

export default {
    name: 'DocSubtypesList',
    props: {
        docType: {
            type: Object,
            required: true
        }
    },
    components: {DocSubtypeIconEditor, DocSubtypeCopyToTeam, DocSubtypeCreate, DocSubtypeSettingsListItem},
    data() {
        return {
            selectedSubtype: null,
            subtypes: [],
            isSubtypesFetching: false
        }
    },
    computed: {
        filtererSubtypes() {
            return this.subtypes.filter(s => !s.isHidden)
        }
    },
    methods: {
        async fetchDocSubtypes() {
            this.isSubtypesFetching = true
            const {data, error} = await documentTypesApiService.fetchSubtypes(this.docType.type)
            if (error) {
                showErrorMessage('Failed to load subtypes')
            } else {
                this.subtypes = data
            }
            this.isSubtypesFetching = false
        },

        deleteSubtype(data) {
            const idx = this.subtypes.findIndex(s => s.uuid === data.uuid)
            if (idx !== -1) {
                this.$delete(this.subtypes, idx)
            }
        },

        editSubtype(data) {
            this.$modal.show('doc-subtype-settings-subtype', {
                docTypeKey: data.section,
                docSubtypeKey: data.property
            })
        },

        onCopyToTeam() {
            this.$modal.show('copy-doc-subtypes-to-team', {
                subtypes: this.filtererSubtypes
            })
        },

        onRefresh() {
            this.fetchDocSubtypes()
            EventBus.$emit('REFRESH-DOC-SUBTYPES')
        }
    },
    mounted() {
        this.fetchDocSubtypes()
        this.$bus.$on('DOC_SUBTYPE_UPDATE', subtype => {
            if (subtype && subtype.uuid) {
                const idx = this.subtypes.findIndex(s => s.uuid === subtype.uuid)
                if (idx !== -1) {
                    this.$set(this.subtypes, idx, {...this.subtypes, ...subtype})
                }
            }
        })
    },
    beforeDestroy() {
        this.$bus.$off('DOC_SUBTYPE_UPDATE')
    }
}
</script>

<style scoped lang="scss">
.list-group-item {
    &:hover {
        cursor: pointer;
        background: $color-purple-soft;
    }
}
</style>
